import { render, staticRenderFns } from "./promotion-item.vue?vue&type=template&id=08e94357&"
import script from "./promotion-item.vue?vue&type=script&lang=js&"
export * from "./promotion-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports